






































































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { patrolManagementServe } from '@/api/installServer';
import DialogDetail1Info from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/dialogDetail1-1.vue';

@Component({
  components: { DialogDetail1Info },
})
export default class DialogDetail1 extends Vue {
  private dialogVisible = false;

  // 表单数据
  private formData: any = {};
  private showDialog(data: any) {
    this.dialogVisible = true;
    this.getData(data.id);
  }
  private getData(id: any) {
    patrolManagementServe.getPatrolTaskInfoData(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
      } else {
      }
    });
  }

  openWarningData(data: any) {
    const taskAbnormalDialogComponent: any = this.$refs['DialogDetail1Info'];
    taskAbnormalDialogComponent.showDialog(data);
  }

  handleClose(done: any) {
    done();
  }
}
